import type { IPublicClientApplication } from "@azure/msal-browser";
import type { Edge, Node } from "@xyflow/react";

export enum DocumentViewMode {
    TABLE = "table",
    EXPLODE = "explode",
}

export enum NodeKind {
    BUCKET = "bucket",
}

export enum NodeRole {
    ROOT = "root",
    GROUP = "group",
}

export interface BucketSelection {
    field: string;
    value: string;
}

export interface SelectableField {
    value: string;
    label: string;
}

export interface CountBucket {
    value: string;
    count: number;
}

export interface FacetValue {
    key: string;
    doc_count: number;
}

export interface FacetField {
    field: string;
    facets: FacetValue[];
}

export interface FacetFilter {
    key: string;
    value: string[];
}

export interface FetchFacetsParams {
    instance: IPublicClientApplication;
    index: string;
    filters: FacetFilter[];
}

export interface BuildFacetGraphParams {
    categories: CountBucket[];
    categoryField: string;
    rootLabel: string;
    expandedValue?: string;
    subItems?: CountBucket[];
    subField?: string;
}

export interface UseOverviewGraphParams {
    index: string;
    rootLabel: string;
    category: string;
    subCategory?: string;
    expanded?: string;
}

export type ExplodeNodeData = {
    label: string;
    role: NodeRole;
    selection: BucketSelection[];
    count?: number;
    dimmed?: boolean;
    focused?: boolean;
};

export interface ExplodeFlow {
    nodes: Node<ExplodeNodeData>[];
    edges: Edge[];
}

export interface ExpandGraphProps {
    index: string;
    rootLabel: string;
    category: string;
    subCategory?: string;
    expanded?: string;
    onToggleExpand: (value: string) => void;
    onOpen: (selection: BucketSelection[]) => void;
}

export interface DocumentViewsProps {
    index: string;
    rootLabel: string;
    fields: SelectableField[];
    onFilteredCountChange?: (count: number) => void;
}
